class CtbModalTrigger extends HTMLElement {
  connectedCallback () {
    this.openButton = this.querySelector('[data-ctb-modal-open]')
    if (this.openButton) {
      this.openButton.addEventListener('click', this.handleOpen.bind(this))
    }
  }

  handleOpen () {
    const modal = document.querySelector('reusable-modal')
    if (!modal) return

    const modalTitle = modal.querySelector('.reusable-modal__title')
    const modalBody = modal.querySelector('.reusable-modal__body')

    const title = this.dataset.modalTitle || ''
    const body = this.decodeHtml(this.dataset.modalBody || '')
    const ctaLabel = this.dataset.modalCtaLabel || ''
    const ctaUrl = this.dataset.modalCtaUrl || ''
    const imageUrl = this.dataset.modalImage || ''

    if (modalTitle) {
      modalTitle.textContent = title
    }

    if (modalBody) {
      const imageHtml = imageUrl
        ? `<div class="ctb-modal__image mb-4 rounded-lg overflow-hidden"><img src="${imageUrl}" alt="" class="w-full h-auto object-cover" loading="lazy"></div>`
        : ''

      const ctaHtml = ctaLabel && ctaUrl
        ? `<div class="ctb-modal__actions mt-6"><a class="button button-primary w-full justify-center leading-none" href="${ctaUrl}"><span>${ctaLabel}</span><span class="sr-only">Go to Club TentBox</span></a></div>`
        : ''

      modalBody.innerHTML = `${imageHtml}<div class="ctb-modal__content tb-in-page-content tb-list-fix text-iron">${body}</div>${ctaHtml}`
    }

    window.dispatchEvent(new CustomEvent('open:modal', {
      detail: { width: 'min(520px, 100svw)' },
    }))
  }

  decodeHtml (value) {
    const textarea = document.createElement('textarea')
    textarea.innerHTML = value
    return textarea.value
  }
}

if (!customElements.get('ctb-modal-trigger')) {
  customElements.define('ctb-modal-trigger', CtbModalTrigger)
}
